import { SagaIterator } from "@redux-saga/types";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../../../enumerations/HttpResponseTypeEnum";
import NewUserNameInfoActions from "../../../redux-container/login/new-user-name-info/NewUserNameInfoRedux";

export function* setNewUserName(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.setNewUserName, action.data);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(NewUserNameInfoActions.newUserNameInfoSuccess(response.data));
    } else {
      yield put(NewUserNameInfoActions.newUserNameInfoFailure(response.data));
    }
  } catch (error) {
    yield put(NewUserNameInfoActions.newUserNameInfoFailure(error));
  }
}
